import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import './ShareClub.css';

const ShareClub = ({ clubUrl, clubTitle }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(clubUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="share-club-container">
      <label className="share-label">Share this club</label>
      <div className="share-input-wrapper">
        <input 
          type="text" 
          value={clubUrl} 
          readOnly 
          className="share-input"
          onClick={(e) => e.target.select()}
        />
        <button 
          className={`copy-button ${copied ? 'copied' : ''}`}
          onClick={handleShare}
        >
          {copied ? (
            <>
              <Check size={18} />
              <span>Copied</span>
            </>
          ) : (
            <>
              <Copy size={18} />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ShareClub;
